var _rect, _path, _path2, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipeTurnsUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PipeTurnsUp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.91,8.06",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93,9.5a2.64,2.64,0,0,1-2,1.12A2.67,2.67,0,0,1,.28,8,2.68,2.68,0,0,1,2.9,5.38a2.55,2.55,0,0,1,1.9,1A2.71,2.71,0,0,1,4.93,9.5Z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.37,
    y1: 8,
    x2: 15.72,
    y2: 8,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5.38,
    y1: 5.94,
    x2: 5.38,
    y2: 10.17,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeTurnsUp);
export default __webpack_public_path__ + "static/media/PipeTurnsUp.d89ca47c2c51bbabff0a74afb9617c95.svg";
export { ForwardRef as ReactComponent };